import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  GET_DATA_INDEX,
  GET_DATA_SHOW,
  DATA_CREATE,
  DATA_EDIT,
  DATA_DELETE,
} from "./actionTypes";

import { apiError, apiSuccess, setDataIndex, setDataShow } from "./actions";

import axios from "axios";

import { integerBetween } from "../../Libs/CustomMethods/customMethods";
import { getErrorMessage } from "../../Libs/SagaUtils/sagaUtils";

const apiEndPoint = "/mural";

function* getDataIndex({ payload: { page, qnt, filter, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `${apiEndPoint}?${
        (page ? `&page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (filter?.category ? `&category=${filter.category}` : "") +
        (filter?.title ? `&title=${filter.title}` : "") +
        (isForm ? `&form=${isForm}` : "")
      }`
    );
    let status = response?.status;
    let data = response?.data;
    if (integerBetween(status, 200, 299) && data?.data) {
      yield put(setDataIndex(data.data));
    } else {
      throw data;
    }
  } catch (error) {
    let message = getErrorMessage(error);
    yield put(apiError(message));
  }
}

function* getDataShow({ payload: { idData, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `${apiEndPoint}?${
        (idData ? `&id=${idData}` : "") + (isForm ? `&form=${isForm}` : "")
      }`
    );
    let status = response?.status;
    let data = response?.data;
    if (integerBetween(status, 200, 299) && data?.data) {
      yield put(setDataShow(data.data));
    } else throw data;
  } catch (error) {
    let message = getErrorMessage(error);
    yield put(apiError(message));
  }
}

function* dataCreate({ payload: { newDataValues } }) {
  try {
    const response = yield call(axios.post, `${apiEndPoint}`, newDataValues);
    let status = response?.status;
    let data = response?.data;
    if (integerBetween(status, 200, 299) && data?.message) {
      let message = data.message;
      yield put(apiSuccess(message));
    } else {
      throw data;
    }
  } catch (error) {
    let message = getErrorMessage(error);
    yield put(apiError(message));
  }
}
function* dataEdit({ payload: { idData, newDataValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `${apiEndPoint}?${idData ? `&id=${idData}` : ""}`,
      newDataValues
    );
    let status = response?.status;
    let data = response?.data;
    if (integerBetween(status, 200, 299) && data?.message) {
      let message = data.message;
      yield put(apiSuccess(message));
    } else {
      throw data;
    }
  } catch (error) {
    let message = getErrorMessage(error);
    yield put(apiError(message));
  }
}
function* dataDelete({ payload: { idData } }) {
  try {
    const response = yield call(
      axios.delete,
      `${apiEndPoint}?${idData ? `&id=${idData}` : ""}`
    );
    let status = response?.status;
    let data = response?.data;
    if (integerBetween(status, 200, 299) && data?.message) {
      let message = data.message;
      yield put(apiSuccess(message));
    } else {
      throw data;
    }
  } catch (error) {
    let message = getErrorMessage(error);
    yield put(apiError(message));
  }
}

export function* watchGetDataIndex() {
  yield takeEvery(GET_DATA_INDEX, getDataIndex);
}

export function* watchGetDataShow() {
  yield takeEvery(GET_DATA_SHOW, getDataShow);
}

export function* watchDataCreate() {
  yield takeEvery(DATA_CREATE, dataCreate);
}
export function* watchDataEdit() {
  yield takeEvery(DATA_EDIT, dataEdit);
}
export function* watchDataDelete() {
  yield takeEvery(DATA_DELETE, dataDelete);
}

function* authSaga() {
  yield all([
    fork(watchGetDataIndex),
    fork(watchGetDataShow),
    fork(watchDataCreate),
    fork(watchDataEdit),
    fork(watchDataDelete),
  ]);
}

export default authSaga;
